import { addCode } from './hacker'

const REPL_RESET = 'REPL_RESET'
const REPL_SET_CODE = 'REPL_SET_CODE'
const REPL_SET_LOCAL_CODE = 'REPL_SET_LOCAL_CODE'
const REPL_SET_ENGINE = 'REPL_SET_ENGINE'
const RELP_SET_ENGINES = 'RELP_SET_ENGINES'
const REPL_SET_OUTPUT = 'REPL_SET_OUTPUT'
const REPL_ON_ERROR = 'REPL_ON_ERROR'
const REPL_ON_PATCH = 'REPL_ON_PATCH'
const REPL_ON_VIEW_ERROR = 'REPL_ON_VIEW_ERROR'


const initialState = {
  code: '',
  localCode: '',
  engine: '',
  engines: [],
  output: '',
  patchSubmitted: false,
  errorViewed: true,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REPL_RESET:
      return {
        ...state,
        code: '',
        localCode: '',
        engine: '',
        engines: [],
        output: '',
        patchSubmitted: false,
        errorViewed: true,
      }
    case REPL_SET_LOCAL_CODE:
      return {
        ...state,
        localCode: action.localCode,
      }
    case REPL_SET_CODE:
      return {
        ...state,
        code: action.code,
        localCode: action.code,
      }
    case REPL_SET_ENGINE:
      return {
        ...state,
        engine: action.engine,
        output: '',
      }
    case RELP_SET_ENGINES:
      return {
        ...state,
        engine: action.engine,
        engines: action.engines,
        code: '',
        localCode: '',
        output: '',
      }
    case REPL_SET_OUTPUT:
      return {
        ...state,
        output: action.output,
      }
    case REPL_ON_ERROR:
      return {
        ...state,
        errorViewed: false,
      }
    case REPL_ON_PATCH:
      return {
        ...state,
        patchSubmitted: true,
      }
    case REPL_ON_VIEW_ERROR:
      return {
        ...state,
        errorViewed: true,
      }
    default:
      return state
  }
}

export function replSetCode(code) {
  return {
    type: REPL_SET_CODE,
    code,
  }
}

export function replSetLocalCode(localCode) {
  return {
    type: REPL_SET_LOCAL_CODE,
    localCode,
  }
}

export function replSetEngine(engine) {
  localStorage.setItem('hackedu.lastLessonLanguage', engine)
  return {
    type: REPL_SET_ENGINE,
    engine,
  }
}

export function replSetDefaultEngine() {
  return (dispatch, getState) => {
    const state = getState()
    const { engines } = state.repl
    const defaultEngine = localStorage.getItem('hackedu.lastLessonLanguage')
    if (engines.includes(defaultEngine)) {
      dispatch(replSetEngine(defaultEngine))
    } else if (engines.includes('python')) {
      dispatch(replSetEngine('python'))
    } else {
      dispatch(replSetEngine(engines[0]))
    }
  }
}

export function replSetEngines(engines) {
  engines.sort()
  const engine = 'python'
  return {
    type: RELP_SET_ENGINES,
    engine,
    engines,
  }
}

export function replReset() {
  return {
    type: REPL_RESET,
  }
}

export function replSetOutput(output) {
  let originalOutput = output
  if (originalOutput === null) {
    originalOutput = ''
  }

  console.log(originalOutput) // print full code output

  let cleanOutput = output
  const ignoredOutputs = [
    'Note: /opt/repl/engines/java/src/main/java/demo/Adapter.java uses unchecked or unsafe operations.',
    'Note: /opt/repl/engines/java/src/main/java/demo/External.java uses or overrides a deprecated API.',
    'msbuild /p:Configuration=Release',
    'Note: Some input files use unchecked or unsafe operations.',
  ]
  ignoredOutputs.forEach((ignoredOutput) => {
    if (originalOutput.startsWith(ignoredOutput) && !originalOutput.includes('Build FAILED.')) {
      cleanOutput = ''
    }
  })
  return {
    type: REPL_SET_OUTPUT,
    output: cleanOutput,
  }
}

export function replOnError() {
  return {
    type: REPL_ON_ERROR,
  }
}

export function replOnPatch(contentId, engine, code, hasTest) {
  return async (dispatch, getState) => {
    const state = getState()
    if (hasTest && state.auth.authenticationStatus === 'LOGGED_IN' && contentId !== null) {
      await dispatch(addCode(contentId, engine, code))
    }
    return dispatch({
      type: REPL_ON_PATCH,
    })
  }
}

export function replOnViewError() {
  return {
    type: REPL_ON_VIEW_ERROR,
  }
}
